import { IconBullseyeRegular, IconCloudRegular, IconCube, IconFileRegular, IconGraphQl } from '@swaggerhub-portal/component-library'

import { SEARCH_RESULT_CONTENT_TYPE, SEARCH_RESULT_TYPE, SEARCH_TAB_TYPE } from '~/types/search'

export const getSearchResultIcon = (type?: SEARCH_RESULT_TYPE, contentType?: SEARCH_RESULT_CONTENT_TYPE) => {
  let icon = <IconFileRegular />

  if (contentType === SEARCH_RESULT_CONTENT_TYPE.GRAPH_QL) {
    icon = <IconGraphQl />
  } else {
    switch (type) {
      case SEARCH_RESULT_TYPE.API:
        icon = <IconCloudRegular />
        break
      case SEARCH_RESULT_TYPE.OPERATION:
        icon = <IconBullseyeRegular />
        break
      case SEARCH_RESULT_TYPE.SCHEMA:
        icon = <IconCube width={16} height={16} />
        break
    }
  }

  return (
    <div className="flex items-center justify-center w-5 h-5">
      {icon}
    </div>
  )
}

export const buildSearchParams = (query: string, type: SEARCH_TAB_TYPE, productId?: string) => ({
  type,
  q: query,
  ...(productId ? { productId } : {}),
})